import { PrimaryButton } from '@janeapp/burrito-design-system';
import { useNavigate } from '@tanstack/react-router';

export function NotFound() {
  const navigate = useNavigate();

  const handleStartNewSearch = () => {
    navigate({ to: '/' });
  };

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <div className="max-w-md space-y-6 text-center">
        <div className="space-y-4">
          <h1 className="text-2xl font-semibold text-neutral-90">
            Oops! Page not found
          </h1>
        </div>
        <PrimaryButton
          onClick={handleStartNewSearch}
          className="w-full"
          data-testid="start-new-search-button"
        >
          Start a new search
        </PrimaryButton>
      </div>
    </div>
  );
}
